import { Navigate } from "react-router-dom"

export default function AccountPage()
{

    return <Navigate to="settings" replace={true} />
}
